export default __webpack_public_path__ + "static/media/name-logo.2a5c1d1a.png";